import React from 'react';
import { Card, Empty, Tag } from 'antd';
import Chart from 'react-apexcharts';
import { FundOutlined } from '@ant-design/icons';

const CPUChart = ({ servidor, height = 300 }) => {
  if (!servidor?.datos?.length) {
    return <Card title={servidor?.nombre || 'Sin datos'}><Empty description="No hay datos de CPU disponibles" /></Card>;
  }

  const labels = servidor.datos.map(d => new Date(d.timestamp).getTime());
  const cpuData = servidor.datos.map(d => d.cpu);
  const cpuPromedio = (cpuData.reduce((a, b) => a + b, 0) / cpuData.length).toFixed(2);
  const cpuMaximo = Math.max(...cpuData).toFixed(2);
  const cpuMinimo = Math.min(...cpuData).toFixed(2);

  const getColor = (cpu) => {
    if (cpu < 50) return { line: '#10b759', status: 'Óptimo', tag: 'green' };
    if (cpu < 80) return { line: '#fd7e14', status: 'Moderado', tag: 'orange' };
    return { line: '#dc3545', status: 'Crítico', tag: 'red' };
  };
  const cs = getColor(parseFloat(cpuPromedio));

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span><FundOutlined style={{ marginRight: 8 }} />{servidor.nombre}{servidor.ip && <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>({servidor.ip})</span>}</span>
          <span style={{ fontSize: 12, fontWeight: 'normal' }}>
            <Tag color={cs.tag}>{cs.status}</Tag>
            Promedio: {cpuPromedio}% · Min: {cpuMinimo}% · Max: {cpuMaximo}%
          </span>
        </div>
      }
      style={{ marginBottom: 16 }}
    >
      <Chart
        type="area"
        height={height}
        options={{
          chart: { toolbar: { show: false }, zoom: { enabled: true } },
          stroke: { width: 2, curve: 'smooth' },
          colors: [cs.line],
          fill: { type: 'gradient', gradient: { opacityFrom: 0.3, opacityTo: 0.05 } },
          xaxis: { type: 'datetime', categories: labels, labels: { datetimeFormatter: { hour: 'HH:mm', day: 'dd/MM' } } },
          yaxis: { min: 0, max: 100, title: { text: 'CPU (%)' }, labels: { formatter: v => `${v}%` } },
          grid: { borderColor: '#e5e9f2', strokeDashArray: 3 },
          tooltip: { x: { format: 'dd/MM HH:mm' }, y: { formatter: v => `${v.toFixed(2)}%` } },
          dataLabels: { enabled: false },
        }}
        series={[{ name: 'CPU', data: cpuData }]}
      />
    </Card>
  );
};

export default CPUChart;
